// 节点id map
export enum TargetType {
  Reserve = 'J_reserve_popup_target',
  CheckIn = 'J_check_in_popup_target',
  CheckInByReserve = 'J_reserve_check_in_popup_target',
  Renewal = 'J_renewal_popup_target',
  ReserveExchange = 'J_reserve_exchange_popup_target',
  CheckInExchange = 'J_check_in_exchange_popup_target',
  Reserve4CRS = 'J_CRS_reserve_popup_target',
  ReserveEditor = 'J_reserve_editor_popup_target',
  CheckInEditor = 'J_check_in_editor_popup_target',
  WECHATMomentEditor = 'J_wechat_moment_editor_popup_target',
}

// 获取定位节点
export const createTargetGetter: (id: TargetType) => () => HTMLElement = (id) => () => {
  return document.getElementById(id);
};
